import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { FilterButton } from './FilterButton';

export const FiltersContainer = () => {
  return (
    <div css={filtersContainerStyles}>
      <FilterButton isIconOnly={true} />
    </div>
  );
};

const filtersContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});
